// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".path-planning[data-v-57770adc] {\n  height: calc(100% - 16px);\n  margin: 8px;\n}", ""]);
// Exports
module.exports = exports;
